import React from 'react';
import PropTypes from 'prop-types';

import Description from 'ui/text/Description';
import Label from 'ui/text/Label';

import { currencySymbol } from 'utils/rewards';
import { amountOfProductInCart, useCart } from 'utils/CartContext';
import { calculateLineMaxAmount } from 'utils/calculateProductMaxAmount';

import IconButton from '@mui/material/IconButton';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const CartItem = ({ item }) => {
  const { cartItems, updateQuantity, removeFromCart } = useCart();
  const { product, amount, variant } = item;

  const heldElsewhere = amountOfProductInCart(cartItems, product, variant?.id);
  const maxAmount = calculateLineMaxAmount(product, variant, heldElsewhere);

  const unitPrice = product.display_price || 0;
  const lineTotal = unitPrice * amount;
  const currencySign = currencySymbol[product.currency];

  return (
    <div className="cart-item">
      <div className="cart-item-info">
        <Description bold>{product.title}{variant && ` — ${variant.label}`}</Description>
        <Label secondary>
          {(unitPrice / 100).toFixed(2)} {currencySign}{amount > 1 && ` x ${amount}`}
        </Label>
      </div>

      <div className="cart-item-controls">
        <IconButton
          size="small"
          onClick={() => updateQuantity(product.id, amount - 1, variant?.id)}
        >
          <RemoveIcon fontSize="small" />
        </IconButton>

        <Description>{amount}</Description>

        <IconButton
          size="small"
          onClick={() => updateQuantity(product.id, amount + 1, variant?.id)}
          disabled={amount >= maxAmount}
        >
          <AddIcon fontSize="small" />
        </IconButton>

        <IconButton
          size="small"
          onClick={() => removeFromCart(product.id, variant?.id)}
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </div>

      <Description bold className="cart-price">
        {(lineTotal / 100).toFixed(2)} {currencySign}
      </Description>
    </div>
  );
};

CartItem.propTypes = {
  item: PropTypes.shape({
    product: PropTypes.object.isRequired,
    amount: PropTypes.number.isRequired,
    variant: PropTypes.object,
  }).isRequired,
};

export default CartItem;
